import React from "react";
import { useNavigate } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { useTranslation } from "react-i18next";
import sapIcon from "../assets/sap_icon.png";
import fioriIcon from "../assets/fiori.png";
import URL_MAPPING, {
  EMPLOYEE_PORTAL_URL,
  INTERNAL_FIORI_URL,
} from "../routes/constants";

interface AnalyticalToolButtonProps {
  size?: "default" | "small";
}

const AnalyticalToolButton: React.FC<AnalyticalToolButtonProps> = ({
  size = "default",
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const lang = i18n.language || localStorage.getItem("lang") || "English";
  const isEnglish = lang === "en" || lang === "English" || (typeof lang === "string" && lang.startsWith("en"));

  const handleButtonClick = (item: {
    label: string;
    url: string;
    isInternal?: boolean;
  }) => {
    if (item.isInternal) {
      navigate(item.url);
    } else {
      window.open(item.url, "_blank", "noopener,noreferrer");
    }
  };

  const menuButtons = [
    {
      label: t("hrServices", isEnglish ? "HR Services Guide" : "دليل خدمات الموارد البشرية"),
      url: URL_MAPPING.HR_SERVICES_GUIDE,
      icon: <BookOpen className={size === "small" ? "h-4 w-4 shrink-0" : "h-5 w-5 shrink-0"} />,
      isInternal: true,
    },
    {
      label: t("employeePortal", isEnglish ? "Employee Portal" : "بوابة الموظفين"),
      url: EMPLOYEE_PORTAL_URL,
      icon: sapIcon,
    },
    {
      label: t("internalFiori", isEnglish ? "Internal SAP-FIORI" : "نظام SAP-FIORI الداخلي"),
      url: INTERNAL_FIORI_URL,
      icon: fioriIcon,
    },
  ];

  const isSmall = size === "small";

  return (
    <div className="flex items-center gap-2">
      {menuButtons.map((item) => (
        <button
          key={item.label}
          type="button"
          onClick={() => handleButtonClick(item)}
          className={`inline-flex items-center justify-start gap-2 rounded-md bg-[#9b54a1] hover:bg-culightpurple text-white font-semibold whitespace-nowrap transition-colors shadow-sm ${
            isSmall
              ? "px-2.5 py-1 min-h-[2rem] text-xs"
              : "px-3 py-1.5 min-h-[2.25rem] text-13"
          }`}
        >
          {typeof item.icon === "string" ? (
            <img
              src={item.icon}
              alt=""
              className={`shrink-0 object-contain ${isSmall ? "h-4 w-4" : "h-5 w-5"}`}
              aria-hidden="true"
            />
          ) : (
            item.icon
          )}
          <span className="leading-snug">{item.label}</span>
        </button>
      ))}
    </div>
  );
};

export default AnalyticalToolButton;
